<template>
   <NuxtLink
      :to="disabled ? undefined : to"
      :target="blank ? '_blank' : undefined"
      class="hover:bg-grey/10 flex items-center gap-2 rounded-lg transition-all"
      :class="[
         small ? 'p-1.5' : 'p-2',
         {
            'selected bg-primary/10': selected && !small,
            __clickable: !disabled,
            'pointer-events-none opacity-50': disabled,
            'text-red hover:bg-red/10': type === 'destructive',
         },
      ]"
   >
      <Icon
         v-if="iconBefore || icon"
         :name="iconBefore || icon"
         class="text-primary size-4 shrink-0"
         :class="{
            'text-red': type === 'destructive',
         }"
      />
      <p :class="{ 'body-base text-[0.8125rem]': small, 'font-bold': small && selected }">{{ title }}</p>

      <div class="ml-auto flex shrink-0 items-center gap-4">
         <span v-if="dot" class="bg-red size-2 shrink-0 rounded-full" />
         <slot />
         <Icon
            v-if="iconAfter"
            :name="iconAfter"
            class="text-primary shrink-0 transition-[rotate]"
            :class="{
               'text-red': type === 'destructive',
               '-rotate-180': expanded,
               'size-4': smallIconAfter,
               'size-5': !smallIconAfter,
            }"
            @click.stop="props.onIcon?.()"
         />
      </div>
   </NuxtLink>
</template>

<script lang="ts" setup>
export type MenuItemProps = {
   to?: string
   blank?: boolean
   selected?: boolean
   disabled?: boolean
   iconBefore?: string
   icon?: string
   iconAfter?: string
   expanded?: boolean
   small?: boolean
   smallIconAfter?: boolean
   title: string
   type?: 'default' | 'destructive'
   onIcon?: () => void
   dot?: boolean
}

const props = withDefaults(defineProps<MenuItemProps>(), {
   type: 'default',
})
</script>
